export const iconFontAwesomeMoneyWallet = (
	<i className="fa-solid fa-wallet"></i>
);
